import React, { Component } from "react";
import ChecklistForm from "./checklistForm";

class ChecklistStart extends Component {
  render() {
    return (
      <ChecklistForm
        label="Shift Start Checklist"
        isShiftStartChecklist={true}
        {...this.props}
      />
    );
  }
}

export default ChecklistStart;
